// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__VMLik","bg-myColor":"navbar_bg-myColor__qAZsm","icon":"navbar_icon__JPHtW"};